
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { getCDNUrl } from '@/utils/cdn'

@Component<CredentialsForm>({})
export default class CredentialsForm extends Vue {
    @Prop({ type: String, default: '' }) public logo?: string

    get logoUrl() {
        return getCDNUrl(this.logo)
    }
}
